<template>
  <div
    id="app"
    class="h-full"
  >
    <template v-if="!isIE">
      <IntercomMessenger />

      <RouterView />
    </template>
    <div
      v-else
      class="h-full flex flex-col items-center justify-center"
    >
      <h1 class="text-primary mb-10">Your browser is out-of-date!</h1>
      <p class="mb-20">Update your browser to use Eventor.app and the newest features.</p>
      <a
        href="http://outdatedbrowser.com/"
        class="text-white bg-secondary px-40 py-15 rounded"
      >Update my browser now</a>
    </div>
  </div>
</template>

<script>
import IntercomMessenger from '@/components/IntercomMessenger';

export default {
  components: {
    IntercomMessenger,
  },
  data: () => ({
    isIE: false,
  }),
  created() {
    // IE detection
    if (navigator.appName === 'Microsoft Internet Explorer'
      || !!(navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv:11/))) {
      this.isIE = true;
    }
  },
};
</script>

<style>
</style>
